// @flow
import React from 'react';
import Moment from 'react-moment';

type Props = {
  value: ?string,
  fromNow?: boolean,
};

const DateTime = ({ value, fromNow = false }: Props) => (
  <Moment date={value} fromNow={fromNow} format="H:mm - Do MMM YYYY" />
);

export default DateTime;



// WEBPACK FOOTER //
// ./src/modules/components/DateTime.js